import { Action } from 'redux';
import { ElectionPeriodStateStructure, SelectedElectionPeriodEvent } from '../../angular-elements/shared/interfaces/electionPeriodStateStructure.interface';

const INITIAL_STATE: ElectionPeriodStateStructure = {
    selectedElectionPeriodEvent: null
}

const SET_ELECTION_PERIOD_EVENT = 'SET_ELECTION_PERIOD_EVENT';

export class ElectionPeriodAction implements Action {
    type: string;
    selectedElectionPeriodEvent?: SelectedElectionPeriodEvent;

}

export function setSelectedElectionPeriodEvent(selectedElectionPeriodEvent: SelectedElectionPeriodEvent): ElectionPeriodAction {
    return {
        type: SET_ELECTION_PERIOD_EVENT,
        selectedElectionPeriodEvent
    }
}

export const ELECTION_PERIOD_REDUCER = 'ElectionPeriod';
export function ElectionPeriod(state: ElectionPeriodStateStructure = INITIAL_STATE, action: ElectionPeriodAction) {
    const copiedState = JSON.parse(JSON.stringify(Object.assign({}, state)));
    switch (action.type) {
        case SET_ELECTION_PERIOD_EVENT:
            copiedState.selectedElectionPeriodEvent = action.selectedElectionPeriodEvent;
            return Object.assign({}, state, copiedState);
        default:
            return state;
    }
}